/**
 * axios를 사용하는 메서드는 dataProvider를 사용하지 않기 때문에 헤더의 인증정보가 전송이 안됨. -> 이 파일을 임포트하고 아래처럼 변경
 * ///기존///    
 * return axios
      .put(FxmsData.apiUrl + "/login", { userId: email, userPwd: password })
  ///변경///
  import common from "../jwt/auth-axios-common";

  //1. 토큰 생성후 호출
  return axios
      .put("login", { userId: email, userPwd: password }, common.headers)

  //2. 이미 static으로 만들어진 메서드는 위의 common.header정보를 가지고 오지못함.
  토큰값을 넘겨주고 받아서 처리
            .put("login", { userId: email, userPwd: password }, createTokenHeader(token)
      )
 */

const common = {
  SERVER_URL: process.env.REACT_APP_BACK_BASE_URL + "/",
  headers: {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  },
};

const createTokenHeader = (token) => {
  return {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
};

export { common, createTokenHeader };
export default common;
